import { DefaultTheme } from 'styled-components/dist/types';
import { getIconBackgroundImage } from 'styles/utils';

/** 
These styles refer to the Data Entry and Selection sections inside flowable design
The components customized in this file are:
- Button
- Work Action
- Rest button
- Form buttons
- Wizard buttons
- Modal buttons
- Expression button
- Text
- Number
- Decimal
- Date
- Multiline text
- Rich text
- Password
- Attachment
- Text list
- Radio buttons
- Checkbox
- Checkbox group
- Select (single and multiple)
 */



export const getFlowableButtonStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
   // SECONDARY BUTTON
    .flw__wizard__footer__next.flw__container__footer__next,
    .flw__wizard__footer__previous.flw__container__footer__previous,
    .flw__modal-panel__dialog-button.flw__action__modal__dialog-button.flw-button,
    .flw__modal-panel__dialog-button.flw__container__dialog-button.flw__modal-panel--open__dialog-button.flw__container--open__dialog-button,
    .flw__component.flw__component--button .flw__link--button__a, 
    .flw__rest-button__button.flw__component__button,
    .flw__script-button__button.flw__component__button,
    .flw__outcome-button__button.flw__component__button,
    .flw__action__button.flw__component__button.flw__rest-button__button,
    .flw__wizard__footer__previous.flw__container__footer__previous:focus,
    .flw__modal-panel__dialog-button.flw__action__modal__dialog-button.flw-button:focus,
    .flw__modal-panel__dialog-button:hover, .flw__modal-panel__dialog-button:focus,
    .flw__component.flw__component--button .flw__link--button__a:focus, 
    .flw__rest-button__button.flw__component__button:focus,
    .flw__script-button__button.flw__component__button:focus,
    .flw__outcome-button__button.flw__component__button:focus,
    .flw__action__button.flw__component__button.flw__rest-button__button:focus {
      font-family: ${theme.typography.fontFamily}, sans-serif;
      background-color: ${theme.color.standard_button.secondary.default.background};            
      border: 2px solid ${theme.color.standard_button.secondary.default.border};
      color:  ${theme.color.standard_button.secondary.default.font};
      ${theme.radii.radius8};
      letter-spacing: normal;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      height: 48px;
      text-transform: none;
      transform: none;
      box-shadow: none;
    }
    
    // HOVER SECONDARY BUTTON
    .flw__wizard__footer__previous.flw__container__footer__previous:hover,
    .flw__modal-panel__dialog-button.flw__action__modal__dialog-button.flw-button:hover,
    .flw__modal-panel__dialog-button:hover.flw__modal-panel__dialog-button:hover,
    .flw__component.flw__component--button .flw__link--button__a:hover, 
    .flw__rest-button__button.flw__component__button:hover,
    .flw__script-button__button.flw__component__button:hover,
    .flw__outcome-button__button.flw__component__button:hover,
    .flw__action__button.flw__component__button.flw__rest-button__button:hover {
      background-color: ${theme.color.standard_button.secondary.hover.background};
      border: 2px solid ${theme.color.standard_button.secondary.hover.border};
      color:  ${theme.color.standard_button.secondary.hover.font};
      transform: none;
      box-shadow: none;
    }
    
    // FOCUS SECONDARY BUTTON
    .flw__wizard__footer__previous.flw__container__footer__previous:focus-visible,
    .flw__component.flw__component--button .flw__link--button__a:focus-visible, 
    .flw__rest-button__button.flw__component__button:focus-visible,
    .flw__script-button__button.flw__component__button:focus-visible,
    .flw__outcome-button__button.flw__component__button:focus-visible,
    .flw__action__button.flw__component__button.flw__rest-button__button:focus-visible {
      background-color: ${theme.color.standard_button.secondary.focus.background};
      border: 2px solid ${theme.color.standard_button.secondary.focus.border};
      color:  ${theme.color.standard_button.secondary.focus.font};
      transform: none;
      box-shadow: none;
    }
    
    
    // PRIMARY BUTTON
    .flw__wizard__footer__next.flw__container__footer__next,
    .flw__component.flw__component--button .flw__link--button__a.flw__link--primary__a, 
    .flw__rest-button__button.flw__component__button.flw__rest-button--primary__button,
    .flw__outcome-button__button.flw__component__button.flw__outcome-button--primary__button,
    .flw__script-button__button.flw__component__button.flw__script-button--primary__button,
    .flw__wizard__footer__next.flw__container__footer__next:focus,
    .flw__component.flw__component--button .flw__link--button__a.flw__link--primary__a:focus, 
    .flw__rest-button__button.flw__component__button.flw__rest-button--primary__button:focus,
    .flw__outcome-button__button.flw__component__button.flw__outcome-button--primary__button:focus {
      font-family: ${theme.typography.fontFamily}, sans-serif;
      background-color: ${theme.color.standard_button.primary.default.background};
      border: 2px solid ${theme.color.standard_button.primary.default.border};
      color:  ${theme.color.standard_button.primary.hover.font};
      letter-spacing: normal;
      height: 48px;
      line-height: 24px;
      transform: none;
      box-shadow: none;
    }
    
    //HOVER PRIMARY BUTTON
    .flw__wizard__footer__next.flw__container__footer__next:hover, 
    .flw__component.flw__component--button .flw__link--button__a.flw__link--primary__a:hover, 
    .flw__rest-button__button.flw__component__button.flw__rest-button--primary__button:hover,
    .flw__outcome-button__button.flw__component__button.flw__outcome-button--primary__button:hover,
    .flw__outcome-button__button.flw__component__button.flw__outcome-button--primary__button:hover,
    .flw__script-button__button.flw__component__button.flw__script-button--primary__button:hover {
      background-color: ${theme.color.standard_button.primary.hover.background};
      border: 2px solid ${theme.color.standard_button.primary.hover.border};
      color:  ${theme.color.standard_button.primary.hover.font};
    }
    
    // FOCUS PRIMARY BUTTON
    .flw__wizard__footer__next.flw__container__footer__next:focus-visible,
    .flw__component.flw__component--button .flw__link--button__a.flw__link--primary__a:focus-visible, 
    .flw__rest-button__button.flw__component__button.flw__rest-button--primary__button:focus-visible,
    .flw__outcome-button__button.flw__component__button.flw__outcome-button--primary__button:focus-visible {
      background-color: ${theme.color.standard_button.primary.focus.background};
      border: 2px solid ${theme.color.standard_button.primary.focus.border};
      color:  ${theme.color.standard_button.primary.focus.font};
      transform: none;
      box-shadow: none;
    }
    
    // DISABLED BUTTON
    .flw__component__button.flw__component--disabled__button {
      opacity: 0.4;
      pointer-events: none;
    }
  `
}

export const getFlowableInputStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
  // GENERAL INPUT STYLES
  .flw__text__input,
  .flw__searchbox__input,
  .flw__textarea__input,
  .flw__number__input,
  .flw__date__input,
  .flw__select__input,
  .flw__richText__input,
  .flw__richText .flw__richText__input,
  .flw__richText .flw__richText__input:focus,
  .flw__richText .flw__richText__input:not(.flw__richText--disabled__input),
  .flw__richText .flw__richText__input.flw__richText--disabled__input,
  .flw__richText .flw__richText__input:not(.flw__richText--disabled__input):focus,
  .flw__select__input:focus,
  .flw__text__input:focus,
  .flw__searchbox__input:focus,
  .flw__textarea__input:focus,
  .flw__number__input:focus,
  .flw__date__input:focus,
  div.flw__select__control {
    background-color: ${theme.color.forms.default.background};
    border-color: ${theme.color.forms.default.border};
    color: ${theme.color.general.font.primary};
    ${theme.radii.radius12};
    font-size: 16px;
    line-height: 24px;
    font-style: normal;
    font-weight: 400;
  }
  
  .flw__richText .flw__richText__input:focus, 
  .flw__richText .flw__richText__input:not(.flw__richText--disabled__input):focus,
  .flw__text__input:focus,
  .flw__searchbox__input:focus,
  .flw__textarea__input:focus,
  .flw__number__input:focus,
  .flw__date__input:focus,
  div.flw__select__control--is-focused,
  div.flw__select__control--is-focused:hover {
    border-color: ${theme.color.forms.default.focus.border};
  }
  
  // DISABLE INPUTS
  .flw__component.flw__text--disabled.flw__component--disabled,
  .flw__number.flw__component.flw__number--disabled.flw__component--disabled,
  .flw__select.flw__component.flw__select--disabled.flw__component--disabled,
  .flw__date.flw__component.flw__date--disabled.flw__component--disabled,
  .flw__component__radio__label.flw__radio-group--disabled__radio__label,
  .flw__richText.flw__component.flw__richText--disabled,
  .flw__textarea.flw__component.flw__textarea--disabled,
  .flw__upload.flw__component.flw__upload--disabled,
  .flw__checkbox-group__option.flw__component__option.flw__checkbox-group--disabled__option.flw__component--disabled__option,
  .flw__boolean.flw__component.flw__boolean--disabled.flw__component--disabled {
    opacity: 0.4;
  }
  
  // INPUT LABELS
  label.flw__label.flw__component__label {
    font-weight: 400;
    font-size: 16px;
    color: ${theme.color.general.font.primary};
  }
  
  // RADIO GROUPS
  .flw__radio-group__radio.flw__component__radio {
    display: flex;
    align-items: center;
  }
  input[type=radio].flw__radio-group__input {
    margin-right: 8px;
    margin-top: 0px;
    outline: 0px;
    border: 1px solid ${theme.color.forms.default.border};
    background: ${theme.color.forms.default.background};
  }
  .flw__radio-group__radio--active input[type=radio].flw__radio-group__input:after {
    display: flex;
    margin-top: 3px;
    margin-left: 3px;
    content: " ";
    border-radius: 50%;
    height: 8px;
    width: 8px;
    background: ${theme.color.forms.default.innericons_and_selected};
    
  }
  .flw__label.flw__radio-group__radio__label.flw__component__radio__label {
    font-size: 16px;
    line-height: 24px;
    font-style: normal;
    font-weight: 400;
    color: ${theme.color.general.font.primary};
  }
  div.flw__select__input, div.flw__select__single-value {
    font-size: 16px;
    line-height: 24px;
    font-style: normal;
    font-weight: 400;
    color: ${theme.color.general.font.primary};
  }      
  
  // INPUTS
  .flw__text__input,
  .flw__searchbox__input,
  .flw__textarea__input,
  .flw__number__input,
  .flw__date__input {
    padding: 11px 15px;
    min-height: 49px;
  }
  
  // CHECKBOX
  input[type=checkbox].flw__checkbox-group__input.flw__component__input,
  input[type=checkbox].flw__boolean__input,
  input[type=checkbox].flw__boolean__input:focus {
    margin-right: 8px;
    margin-top: 0px;
    width: 18px;
    height: 18px;    
    box-sizing: content-box;
    cursor: pointer;
    background-color: ${theme.color.forms.default.background};
    outline: 0px;
    border: 1px solid ${theme.color.forms.default.border};
    ${theme.radii.radius4};
  }
  input[type=checkbox].flw__checkbox-group__input.flw__component__input:checked,
  input[type=checkbox].flw__boolean__input:checked {
    background-color: ${theme.color.forms.default.background};
    border-color: ${theme.color.forms.default.border};
    ${getIconBackgroundImage('icn_check', theme.color.link.default)};
  }
  
  .flw__label.flw__checkbox-group__option__label {
    font-weight: 400;
    font-size: 16px;
    color: ${theme.color.general.font.primary};
  }
  
  // DROPDOWN
  .flw__select__input.flw__component__input .flw__select__indicators .flw__select__indicator-separator {
    display: none;
  } 
  .flw__select__control .flw__select__value-container {
    padding: 11px 15px;
  }
  .flw__select__control .flw__select__value-container div.flw__select__multi-value,
  .flw__select__control .flw__select__value-container div.flw__select__multi-value__remove:hover {
    background: ${theme.color.tag.dark.background};
    ${theme.radii.radius8}
  }
  .flw__select__control div.flw__select__multi-value__label {
    color: ${theme.color.tag.dark.font};
  }
  .flw__select__control div.flw__select__multi-value__remove svg{
    margin-bottom: 2px;
    width: 17px;
    height: 17px;
    fill: ${theme.color.tag.dark.font};
  }
  .flw__select--menu-top__input .flw__select__menu {
    ${theme.radii.radius12};
    margin-bottom: 4px;
    border: none;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
  }
  div.flw__select__menu {
    ${theme.radii.radius12};
    margin-top: 4px;
    border: none;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
    left: 0;
    background-color: ${theme.color.contextual_modal_box.background};
  }
  div.flw__select__option,
  div.flw__select__option:active,
  div.flw__select__option--is-selected,
  div.flw__select__option--is-focused {
    padding: 8px 0px 8px 16px;
    transition: all .25s;
    cursor: pointer;
    background-color: ${theme.color.contextual_modal_box.background};
    color: ${theme.color.general.font.primary};
  }
  div.flw__select__option--is-focused {
    background: rgba(0, 0, 0, 0.02);
  }

  div.flw__select__option--is-selected {
    font-weight: 400;
  }
  
  // FILE SELECTOR
  .flw__fileSelector.flw__fileSelector--multiple {
    border: 2px dashed ${theme.color.forms.default.border};
    background: ${theme.color.containers.bordered.background};
    ${theme.radii.radius12};
  }
  .flw__fileCard__fileName--downloadable:before {
    display: none;
  }
  .flw__fileSelector .flw__fileCard {
    background: ${theme.color.forms.default.background};
  }
  .flw__fileSelector .flw__fileCard__fileName--downloadable.flw__fileCard__fileName {
    color: ${theme.color.link.default};
  }
  .flw__fileCard__fileAction--button.flw__fileCard__fileAction svg{
    fill: ${theme.color.link.default};
  }
  .flw__fileCard__fileSize--no-icon.flw__fileCard__fileSize,
  .flw__fileSelector .flw__message.flw__fileSelector__message.flw__fileSelector--empty__message,
  .flw__message.flw__fileSelector__message.flw__fileSelector--none__message {
    color: ${theme.color.general.font.secondary};
  }
  .flw__fileCard__progressbar--existing__value, 
  .flw__fileCard__progressbar--uploading__value,
  .flw__fileCard__progressbar--success__value {
    background-color: ${theme.color.progress_and_loading.main};
    ${theme.radii.radius4}
  }
  .flw__fileSelector.flw__fileSelector__paste  {
    display: none;
  }
  
  // DATE PICKER
  .flw__date .react-datepicker__header {
    background: ${theme.color.tag.dark.background};
  }
  .flw__date .react-datepicker__header--time, 
  .flw__date .react-datepicker__header__dropdown, 
  .flw__date .react-datepicker__time,
  .flw__date .react-datepicker__day-name {
    color: ${theme.color.tag.dark.font};
  }
   .flw__date .react-datepicker__navigation-icon--previous {
    border-right-color: ${theme.color.tag.dark.font};
  }
  .flw__date .react-datepicker__navigation-icon--next {
    border-left-color: ${theme.color.tag.dark.font};
  }
  .flw__date .react-datepicker__month-read-view--down-arrow, .flw__date .react-datepicker__year-read-view--down-arrow {
     border-top-color: ${theme.color.tag.dark.font};
  }
 .flw__date .react-datepicker__month-container {
    background-color: ${theme.color.contextual_modal_box.background}
  }
  .flw__date .react-datepicker__day {
    color: ${theme.color.general.font.primary};
  }
 
  .flw__date .react-datepicker__day--keyboard-selected, .flw__date .react-datepicker__day--selected {
    border-color: ${theme.color.standard_button.primary.default.background};
  }
  .flw__date .react-datepicker__day:hover {
    background: ${theme.color.tag.dark.background};
    color: ${theme.color.tag.dark.font};
  }
  `
}
